import React from 'react'
import { Layout } from 'antd'
import PropTypes from 'prop-types'

import { StyledPage, StyledPageContent } from '../styled'

import NavigationBar from './navigation-bar'

const Page = ({ children }) => (
  <Layout>
    <StyledPage>
      <NavigationBar />
      <StyledPageContent>
        <Layout.Content>{children}</Layout.Content>
      </StyledPageContent>
    </StyledPage>
  </Layout>
)

Page.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Page
